import { graphql, useStaticQuery } from 'gatsby';
import { usePageContext } from 'gatsby-theme-thepuzzlers-core';

export const usePrismicNavigation = () => {
  const { locale } = usePageContext();

  const data = useStaticQuery(graphql`
    fragment NavigationFields on PrismicNavigationDataType {
      menu_btn
      page_links {
        text
        to {
          url
        }
      }
      language {
        german
        english
      }
    }

    query NavigationQuery {
      en: prismicNavigation(lang: { eq: "en-us" }) {
        data {
          ...NavigationFields
        }
      }

      de: prismicNavigation(lang: { eq: "de-de" }) {
        data {
          ...NavigationFields
        }
      }
    }
  `);

  return data[locale];
};
